<template>
  <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
    <MediaLibraryCard
      v-for="item in items"
      :key="item.id"
      :item="item"
      :is-selected="item.id === selectedId"
      :variant="variant"
      @select="emit('select', $event)"
    />
  </div>
</template>

<script lang="ts" setup>
import type { Media as RosMedia } from '@carvia/ros-client-types';
import MediaLibraryCard from '@/components/media/MediaLibraryCard.vue';

withDefaults(
  defineProps<{
    items: RosMedia[];
    selectedId?: string | null;
    variant?: 'default' | 'onWhiteBackground';
  }>(),
  {
    variant: 'default',
  },
);

const emit = defineEmits<{
  (e: 'select', item: RosMedia): void;
}>();
</script>
